import { BackendValidationErrors } from '../interfaces/backend-validation-errors.interface';
import { FormGroupExt } from '../../form-ext/form-group.ext';
import { get, keys } from 'lodash-es';

export class UserReadableError extends Error {
    public validationErrors: BackendValidationErrors | null;
    public statusCode: number;

    constructor(message: string, status: number, errors: BackendValidationErrors | null = null) {
        super(message);
        this.validationErrors = errors;
        this.statusCode = status;
    }

    public setBackendErrorsInForm(groupExt: FormGroupExt): void {
        if (this.validationErrors === null) {
            return;
        }

        for (const field of Object.keys(this.validationErrors)) {
            const formControl = groupExt.group.get(field);

            if (!formControl) {
                continue;
            }

            formControl.markAsTouched();
            formControl.setErrors(this.validationErrors[field]);
        }

        groupExt.setBackendErrors(this.validationErrors);
    }

    public isValidationError(): boolean {
        return this.validationErrors !== null;
    }

    public getFirstError(field: string): string {
        const fieldErrors = get(this.validationErrors, field, {});
        const errorCodes = keys(fieldErrors);

        if (!errorCodes.length) {
            return '';
        }

        return get(fieldErrors, errorCodes[0], '');
    }
}
